/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swift_Rose_Deer_SetInputs */

const en_swift_rose_deer_set = /** @type {(inputs: Swift_Rose_Deer_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure`)
};

const de_swift_rose_deer_set = /** @type {(inputs: Swift_Rose_Deer_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurieren`)
};

/**
* | output |
* | --- |
* | "Configure" |
*
* @param {Swift_Rose_Deer_SetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const swift_rose_deer_set = /** @type {((inputs?: Swift_Rose_Deer_SetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swift_Rose_Deer_SetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_swift_rose_deer_set(inputs)
	return de_swift_rose_deer_set(inputs)
});